export default function Close() {
  return (
    <div
      className="axa-icon-icon-close"
      dangerouslySetInnerHTML={{
        __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20.772" height="20.716" viewBox="0 0 20.772 20.716"><g id="Group_Copy_7" data-name="Group Copy 7" transform="translate(10.519 -7.102) rotate(45)"><path id="Line_4" data-name="Line 4" d="M1.506,0V24.92" transform="translate(10.539)" fill="none" stroke="#000" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"/><path id="Line_4_Copy" data-name="Line 4 Copy" d="M24.92,1.882H0" transform="translate(0 10.539)" fill="none" stroke="#000" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"/></g></svg>`,
      }}
    />
  )
}
